module.exports = __webpack_public_path__ + "img/slide_003_w.8e380bb6.jpg";